// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__hBM_E","label":"styles_label__p_Oh8","icon":"styles_icon__lXP3I"};